module.exports = __webpack_public_path__ + "static/media/yay.3be46297.gif";